<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <circle class="a" cx="12" cy="12" r="6.75" />

        <line class="a" x1="12" y1="2.25" x2="12" y2="0.75" />

        <line class="a" x1="18.894" y1="5.106" x2="19.955" y2="4.045" />

        <line class="a" x1="21.75" y1="12" x2="23.25" y2="12" />

        <line class="a" x1="18.894" y1="18.894" x2="19.955" y2="19.955" />

        <line class="a" x1="12" y1="21.75" x2="12" y2="23.25" />

        <line class="a" x1="5.106" y1="18.894" x2="4.045" y2="19.955" />

        <line class="a" x1="2.25" y1="12" x2="0.75" y2="12" />

        <line class="a" x1="5.106" y1="5.106" x2="4.045" y2="4.045" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'SunIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 18,
        },
        height: {
            type: [Number, String],
            default: 18,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
